import React, {memo, useCallback} from "react";
import {Alert, Button} from "@mui/material";
import {FallbackProps} from "react-error-boundary/dist/declarations/src/types";

export const Error: React.ComponentType<FallbackProps> = memo(({error, resetErrorBoundary}) => {
  const reload = useCallback(() => {
    resetErrorBoundary();
    window.location.reload();
  }, [resetErrorBoundary]);

  return (
    <Alert severity="error" action={<Button color="error" variant={"contained"} size="small" onClick={reload}>
      Recharger
    </Button>}>
      Une erreur est survenue, merci de recharger la page.

      {error && (
        <>
          <br/><br/>
          {error.message}
        </>
      )}
    </Alert>
  );
});

export default Error;
